// One step of the loading screen's warm-up (Axel 2026-10-10: all the start-up work happens behind
// the loading screen, so the app never stutters later). A step is a file of its own,
// `<feature>/<name>.warmup.ts` ending in `export const warmup = defineWarmup({…})`, collected by
// shell/warmup/registry.ts (import.meta.glob): a new step needs no edit anywhere else. Its label is
// a key of the `warmup` i18n area (i18n/areas/warmup.ts).
//
// A step file is imported eagerly with the shell, so it stays light: anything heavy (the engine,
// a section) is imported inside `run`.
//
// Room for more: a Kielioppi step (its tables) would be `grammar/grammar.warmup.ts` with an order
// after the sections and a `grammar` label.
import type { Messages } from '../../i18n';

export type WarmupLabel = Exclude<keyof Messages['warmup'], 'progress'>;

export interface WarmupContext {
  /** How far this step is, 0..1 (the screen's line fills with it). */
  progress(fraction: number): void;
  /** Let the screen paint (between slices of a long step). */
  pause(): Promise<void>;
  /** Resolves when the app's data are loaded (or failed to load): state/actions initApp. */
  appReady: Promise<void>;
}

export interface WarmupStep {
  id: string;
  /** Ascending; leave gaps. */
  order: number;
  label: WarmupLabel;
  /** Also under `npm run dev` (false: only in a build, e.g. code chunks that dev mode does not have). */
  dev?: boolean;
  /** Throwing (offline with nothing cached, a network error) ends the step: the app goes on without it. */
  run(ctx: WarmupContext): Promise<void>;
}

export const defineWarmup = (s: WarmupStep): WarmupStep => s;
